import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=36ee8836&"
import script from "./PageTwo.vue?vue&type=script&lang=js&"
export * from "./PageTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports